import ShareIcon from '../../../../assets/share-gray-icon.svg';
import AvatarDefault from '../../../../assets/medium_default_optimized.png';
import TrashIcon from '../../../../assets/bin-red-icon.svg';
import { commentApi } from '../../../../apis/comment.api';
import ToastBtnMessage from '../../../ToastBtnMessage';
import { useState } from 'react';
import ShareContentModal from '../../../ShareContentModal';
import DeleteCommentModal from '../../../Modal/DeleteCommentModal';
import { useNavigate } from 'react-router-dom';
import { convertTimeCreatedAt } from '../../../../constants';
import LexicalCommentViewer from '../../../../components/Lexical/LexicalCommentViewer';
import {
  useToast,
  Text,
  Menu,
  MenuButton,
  MenuList,
  Button,
  MenuItem,
  Divider
} from '@chakra-ui/react';
import { MoreHorizontal } from 'lucide-react';
import CardArticle from './card-article.component';

const CardComment = ({ item, index, isHiddenFeaturedArticles, isMyProfile, isMyArticle }) => {
  const [modal, setModal] = useState('');
  const navigate = useNavigate();
  const [isDeleted, setIsDeleted] = useState(false);
  const toast = useToast();

  const handleDelete = async (id) => {
    try {
      setIsDeleted(true);
      await commentApi.deleteComment(id); // Valid comment ID
      setModal('');
      toast({
        render: () => (
          <ToastBtnMessage
            title={'Comment successfully deleted!'}
            isError={false}
            color="jet-black"
            isHiddenButton
          />
        ),
        status: 'error',
        duration: 2000,
        isClosable: true,
        position: 'top'
      });
    } catch (error) {
      console.error('Failed to delete comment:', error);
      setIsDeleted(false);
    }
  };

  return (
    <div id={item?.id} className="flex flex-col gap-4">
      <div className="flex justify-between items-center gap-[8px] cursor-pointer">
        <div className="flex items-center gap-[8px]">
          <img
            className={`${index === 0 && !isHiddenFeaturedArticles ? 'w-[40px] h-[40px]' : 'w-[32px] h-[32px]'} flex-shrink-0 rounded-full object-cover self-start`}
            src={item?.user?.imgUrl || AvatarDefault}
            alt=""
            onClick={() => navigate(`/${item?.username}`)}
          />
          <div className="flex flex-col">
            <p className="font-[600] line-clamp-2 !text-02-dim-gray">
              {convertTimeCreatedAt(item?.createdAt)}
            </p>
            {!isDeleted ? (
              <LexicalCommentViewer key={item?.id} className="" content={item?.content} />
            ) : (
              <Text fontStyle={'italic'} color={'dim-gray'} fontWeight={400}>
                This comment has been deleted
              </Text>
            )}
          </div>
        </div>
        <Menu>
          <MenuButton
            as={Button}
            className="self-start"
            variant="unstyled"
            border="none"
            boxShadow="none"
            h="32px"
            size="sm"
            rounded="full"
            _hover={{
              bg: '#F0F0F0'
            }}
          >
            <MoreHorizontal className="ml-1 w-4 h-4 md:w-6 md:h-6" />
          </MenuButton>
          <MenuList bg={'#FFFFFF'} minW={'unset'} p={'0.625rem'} shadow={'md'} rounded={'12px'}>
            <MenuItem
              bg={'#FFFFFF'}
              _hover={{ bgColor: 'anti-flash-white' }}
              rounded={'0.5rem'}
              py={'8px'}
              px={'10px'}
              fontSize={'sm'}
              fontWeight={900}
              _focus={{ bgColor: 'anti-flash-white' }}
              onClick={() => {
                setModal('share-comment');
              }}
              icon={<img src={ShareIcon} alt="" className="w-5 h-5" />}
            >
              Share
            </MenuItem>
            {isMyProfile && (
              <MenuItem
                bg={'#FFFFFF'}
                _hover={{ bgColor: 'anti-flash-white' }}
                rounded={'0.5rem'}
                py={'8px'}
                px={'10px'}
                fontSize={'sm'}
                fontWeight={900}
                textColor={'error-red'}
                _focus={{ bgColor: 'anti-flash-white' }}
                icon={<img src={TrashIcon} alt="" className="w-5 h-5" />}
                onClick={() => setModal('delete-comment')}
              >
                Delete
              </MenuItem>
            )}
          </MenuList>
        </Menu>
      </div>

      {/* Clear label for article context */}
      <div className="flex items-center gap-2 mt-2">
        <div className="h-px flex-1 bg-anti-flash-white"></div>
        <p className="text-xs font-semibold text-dim-gray uppercase tracking-wider">Commented on</p>
        <div className="h-px flex-1 bg-anti-flash-white"></div>
      </div>

      <div className="md:gap-[24px] max-w-[604px] mx-auto shadow-[2px_4px_12px_0px_#0000001F] rounded-md p-6 border-l-4 border-growth-green-500">
        <CardArticle
          key={`article-${index}`}
          index={index}
          item={{
            ...item?.article,
            nameCreator: item?.article?.creator?.firstName,
            imgUrl: item?.article?.creator?.imgUrl
          }}
          isHiddenFeaturedArticles={isHiddenFeaturedArticles}
          isProfile={isMyArticle}
        />
      </div>
      <Divider border="1px solid" my="24px" color="anti-flash-white" />

      {/* Mobile */}
      <div className="md:hidden flex flex-wrap items-center gap-2">
        {item?.topics?.slice(0, 4).map((elm) => {
          return (
            <p
              className="bg-[#F0EDEC] rounded-[80px] !text-earth-brown-500 font-semibold text-[10px] px-2 py-1 whitespace-nowrap"
              key={elm.id}
            >
              {elm?.name}
            </p>
          );
        })}
      </div>
      {modal === 'share-article' && (
        <ShareContentModal
          isOpen
          title="Share Article"
          smallTitle="Share this Article!"
          shareUrl={`${process.env.REACT_APP_NEWSLETTER_URL}articles/${item?.article?.alternativeId || item?.article?.id}`}
          media={item?.cover}
          articleId={item?.article?.alternativeId || item?.article?.id}
          onClose={() => setModal('')}
          onClick={() => setModal('')}
          titleBtn="Done"
          minW="439px"
        />
      )}
      {modal === 'share-comment' && (
        <ShareContentModal
          isOpen
          title="Share Comment"
          smallTitle="Share This Comment!"
          shareUrl={`${process.env.REACT_APP_NEWSLETTER_URL}articles/${item?.article?.alternativeId || item?.article?.id}?nav=${item?.nodeId ? 'paragraph' : 'general'}${item?.nodeId ? `&id=${item?.nodeId}` : ''}&commentId=${item?.id}`}
          media={item?.cover}
          onClick={() => setModal('')}
          onClose={() => setModal('')}
          titleBtn="Done"
          minW="439px"
        />
      )}
      {modal === 'delete-comment' && (
        <DeleteCommentModal
          isOpen
          title="Delete Comment"
          smallTitle="This action will permanently delete your comment!"
          media={item?.cover}
          onClose={() => setModal('')}
          onClick={() => handleDelete(item.id)}
          minW="439px"
        />
      )}
    </div>
  );
};

export default CardComment;
